import React, { useEffect } from "react";
import {
  currentUserAction,
  chackValidateUserAction,
  logOutAction,
} from "./app-redux/auth/actions/authActions";
import { useAppDispatch } from "./app-redux/hooks";
import { getRolesAction, getSecurityKeys } from "./app-redux/management/actions/managementActions";
import { WithNotifications } from "./notifications/WithNotifications";
import { AppRouting } from "./routes/AppRouting";
import { CustomMuiTheme } from "./theme/CustomMuiTheme";

function App() {
  console.log("App Rendered 🚀🚀🚀");
  const path = window.location.pathname;
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (path !== "/auth/login") {
      if (!path.includes("/auth/")) {
        checkVialduser();
      }
      dispatch(currentUserAction());
      dispatch(getRolesAction());
      dispatch(getSecurityKeys());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const checkVialduser = async () => {
    const res = await chackValidateUserAction();
    if (res) {
      return;
    } else {
      window.location.replace("/auth/login");
      await logOutAction();
    }
  };
  return (
    <CustomMuiTheme>
      <WithNotifications>
        <AppRouting />
      </WithNotifications>
    </CustomMuiTheme>
  );
}

export default App;
